export default __webpack_public_path__ + "static/media/mercury.d28e3fdf.svg";